import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import type { GalleryItem } from '../types/content';
type AutoGalleryProps = {
  items: GalleryItem[];
  label: string;
  className?: string;
  /** Velocità di scorrimento in pixel al secondo. */
  speed?: number;
};
const slideClass = 'shrink-0 h-[180px] w-[180px] sm:h-[220px] sm:w-[220px] overflow-hidden rounded-[20px] bg-sand';
export function AutoGallery({
  items,
  label,
  className = 'bg-peach',
  speed = 45
}: AutoGalleryProps) {
  const reduceMotion = useReducedMotion();
  const setRef = useRef<HTMLUListElement>(null);
  const [duration, setDuration] = useState(45);
  useEffect(() => {
    const el = setRef.current;
    if (!el) return;
    const update = () => {
      // Larghezza di una serie completa (gap incluso via padding-right) ÷ velocità.
      const width = el.getBoundingClientRect().width;
      if (width > 0) setDuration(width / speed);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [speed, reduceMotion]);
  const renderSlides = (hidden: boolean) => items.map(item => <li key={`${hidden ? 'clone-' : ''}${item.id}`} className={slideClass} data-id="element-19" data-mp="2dm7nrx4wqaic">
        <img src={item.src} alt={hidden ? '' : item.alt} loading="lazy" decoding="async" draggable={false} className="h-full w-full object-cover" data-id="element-20" data-mp="2dk39qmdanv4c" />
      </li>);
  if (reduceMotion) {
    return <section aria-label={label} className={`py-8 sm:py-10 ${className}`} data-id="element-21" data-mp="2nij3kx3phihj">
        <ul tabIndex={0} aria-label={label} className="max-w-6xl mx-auto flex gap-[22px] overflow-x-auto snap-x px-5 sm:px-8 no-scrollbar" data-id="element-22" data-mp="2ikhi65it572w">
          {renderSlides(false)}
        </ul>
      </section>;
  }
  return <section aria-label={label} className={`overflow-hidden py-8 sm:py-10 ${className}`} data-id="element-23" data-mp="2sblyp9o4szzu">
      <div className="marquee-track flex" style={{
      '--marquee-duration': `${duration}s`
    } as React.CSSProperties} data-id="element-24" data-mp="36bmzyq8b69fu">
        <ul ref={setRef} className="flex gap-[22px] pr-[22px]" aria-label={label} data-id="element-25" data-mp="319p7r6hxk4ar">
          {renderSlides(false)}
        </ul>
        <ul className="flex gap-[22px] pr-[22px]" aria-hidden="true" data-id="element-26" data-mp="23x79xrvvd4ii">
          {renderSlides(true)}
        </ul>
      </div>
    </section>;
}